/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag, FcsFlag } from "../unleash";

const RoxPermissionCargo = {};

const FcsPermissionCargo = {
  validation_adjust_weight_proof_photo_enable: new FcsFlag.Flag(false),
  permission_ngen_search_flight_v3: new FcsFlag.Flag(false),
  feature_is_gamification: new FcsFlag.Flag(false),
  permission_cargo_enable: new FcsFlag.Flag(false),
  permission_cargo_detail_view: new FcsFlag.Flag(false),
  permission_cargo_create: new FcsFlag.Flag(false),
  permission_cargo_detail_edit: new FcsFlag.Flag(false),
  config_version_cancel_cargo: new FcsFlag.StringFlag("v2"),
  feature_flight_v2_enable: new FcsFlag.Flag(true),
  permission_cargo_dispute_column_enable: new FcsFlag.Flag(false),
  permission_cargo_dispute_summary_enable: new FcsFlag.Flag(false),
  permission_cargo_print_pti_pdf: new FcsFlag.Flag(false),
  permission_cargo_print_electronic_sptj_pdf: new FcsFlag.Flag(false),
  permission_cargo_print_sptj_pdf: new FcsFlag.Flag(false),
};

const BcsPermissionCargo = {
  validation_3lc_cargo_minimum_weight: new BcsFlag.NumberFlag(0),
  config_ngen_search_flight_path: new BcsFlag.StringFlag("/api/Booking/FlightSearchV3"),
  config_dimension_divider: new BcsFlag.JSONFlag({
    plane: 5000,
    ship: 4000,
    default: 6000
  }),
  config_is_minimum_volume_per_piece: new BcsFlag.JSONFlag(["plane"]),
  feature_gamification_message: new BcsFlag.StringFlag(""),
  config_time_cancel_cargo: new BcsFlag.NumberFlag(2),
  config_interval_auto_refresh_cargo: new BcsFlag.NumberFlag(60),
  config_booking_failed_indicator_pooling_rate: new BcsFlag.NumberFlag(3000),
};

export const FlagsPermissionCargo = {
  ...RoxPermissionCargo,
  ...FcsPermissionCargo,
  ...BcsPermissionCargo
};

export function initFlagsPermissionCargo() {
  // register flags with namespaces for better grouping
  Rox.register("featureCargo", RoxPermissionCargo);
  FcsFlag.register("featureCargo", FcsPermissionCargo);
  BcsFlag.register("featureCargo", BcsPermissionCargo);
}
